<template>
  <div>
    <div class="mt-28px">
      <div class="flex items-center justify-between">
        <p class="title">{{ title }}</p>
        <vs-button color="secondary" @click="openPopup">추가</vs-button>
      </div>
      <vs-table v-model="selectCompany" @selected="handleSelected" pagination :data="companyList" class="mt-5">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th v-for="tHead in tableColumns" :key="`head-${tHead.key}`">{{ tHead.head }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td v-for="tBody in tableColumns" :key="`body-${tBody.key}`">{{ data[indextr][tBody.key] }}</vs-td>
          </vs-tr>
          <div></div>
        </template>
      </vs-table>
    </div>
    <div v-if="!isSimple" class="mt-28px">
      <div class="flex items-center justify-between">
        <p class="title">{{ detailTitle }}</p>
        <vs-button color="secondary" type="border" @click="removeCompany">삭제</vs-button>
      </div>
      <div class="mt-5">
        <div class="writeGridContainer">
          <div>
            <search-nav-item-select class="search-item" label="구분" v-model="selectCompany.com_type" :list="comTypes" :readonly="true" />
          </div>
        </div>
        <div class="writeGridContainer">
          <div>
            <div>{{ detailLabelComName }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_name" />
          </div>
          <div>
            <div>대표자</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_ceo" />
          </div>
          <div>
            <div>사업자번호</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_number" />
          </div>
          <div>
            <div>주소</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_address" />
          </div>
          <div>
            <div>업태</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_business_class" />
          </div>
          <div>
            <div>업종</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_business_type" />
          </div>
          <div>
            <div>담당자</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.director" />
          </div>
          <div>
            <div>연락처</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.phone" />
          </div>
        </div>
      </div>
    </div>

    <popup-search-company :title="popupTitle" v-model="showPopup" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchCompany from "@/popup/PopupSearchCompany";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
export default {
  name: "CompanyAddModule",
  components: {
    SearchNavStartEnd,
    SearchNavItemSelect,
    PopupSearchCompany,
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "담당 부서(업체) 정보";
      },
    },
    isSimple: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    detailTitle: {
      type: String,
      default: () => {
        return "부서(업체) 세부 정보";
      },
    },
    detailLabelComName: {
      type: String,
      default: () => {
        return "부서(업체)명";
      },
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [
          { head: "구분", key: "com_type" },
          { head: "부서(업체)명", key: "com_name" },
          { head: "대표자", key: "com_ceo" },
          { head: "담당자", key: "director" },
          { head: "연락처", key: "phone" },
        ];
      },
    },
    popupTitle: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showPopup: false,
      nav: {
        selects: [
          {
            text: "1",
            value: "1",
          },
        ],
      },
      selectCompany: {},
      companyList: this.value,
      comTypes: [
        {
          text: "본청",
          value: "본청",
        },
        {
          text: "도급",
          value: "도급",
        },
        {
          text: "용역",
          value: "용역",
        },
        {
          text: "위탁",
          value: "본청",
        },
        {
          text: "기타",
          value: "기타",
        },
      ],
    };
  },
  watch: {
    value(data) {
      this.companyList = this.value;
    },
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    handleSelected() {
      this.$emit("selected", this.selectCompany);
    },
    handleClickSelect(company) {
      if (this.findCompanyIndex(company) <= -1) {
        this.companyList.push(company);
      }
    },
    findCompanyIndex(company) {
      let i = 0;
      for (i = 0; i < this.companyList.length; i++) {
        const com = this.companyList[i];
        if (com.id === company.id) {
          return i;
        }
      }
      return -1;
    },
    removeCompany() {
      if (this.selectCompany && this.selectCompany.id) {
        const index = this.findCompanyIndex(this.selectCompany);
        if (index >= 0) {
          const company = this.companyList[index];
          const list = this.companyList.splice(index, 1);

          this.$emit("remove", company);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.size-search {
  width: 200px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}
.search-item {
  width: 100% !important;
  margin: 0 !important;
  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }
  &::v-deep > div:last-child {
    flex: 1 !important;
    .con-select {
      width: 100%;
    }
  }
}
.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
